import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { withRouter } from 'react-router-dom';

export default withRouter(({ isCancel = false, onCancel, match }) => {
  const { dcId, id: serverId } = match.params;

  const fields = [
    { name: 'cdrom', type: 'cdrom', title: 'Image' },
  ];

  const onSave = ({ cdrom }) => {
    actions.server.attachCdRom({ dcId, id: serverId, cdRomId: cdrom?.id });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={{ cdrom: '' }}
      onSubmit={onSave}
      isCancel={isCancel}
      onCancel={onCancel}
    />
  );
});
